import { ValueCardProps } from '../../interfaces/common'

const ValueCard = ({ headerIcon, description, headerText }: ValueCardProps) => {
  return (
    <div className="bg-[#F8F9FA] dark:bg-[#222121] rounded-lg p-6 flex flex-col my-3 md:mx-6 hover:bg-gray-200 dark:hover:bg-[#5e5e5e]">
      <div className="w-12 h-12 mb-4 bg-gray-100 dark:bg-[#3d3b3b] flex justify-center rounded-lg">
        <img src={headerIcon} alt='header' />
      </div>
      <h3 className="text-[32px] leading-[37.54px] font-normal text-black dark:text-gray-300">
        {headerText}
      </h3>
      <p className="mt-4 text-[#ADB5BD] font-500 text-lg dark:text-gray-300">
        {description}
      </p>
    </div>
  )
}

export default ValueCard
